import { cmsApi } from '../../services/CmsService';
import userStore from '../../storage/user';

export default function useCMS() {
  const { endpoint } = cmsApi.getState();
  const token = userStore.getToken();
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  return { endpoint, auth };
}
